<template>
    <div
        class="optimize99-ab-test-container" 
        :style="{
            height: container_height
        }"
        :class="{
            'pa-5': device_type !== 'desktop'
        }"
    >
        <iframe
            id="container_iframe"
            :key="device_type" 
            class="optimize99-ab-test-iframe"
            :class="{
                'optimize99-ab-test-iframe-desktop': device_type === 'desktop',
                'optimize99-ab-test-iframe-tablet': device_type === 'tablet',
                'optimize99-ab-test-iframe-mobile': device_type === 'mobile',
            }"
            ref="iframeRef" 
            :src="edit_src" 
            @load="handleIframeLoad"
        >
        </iframe>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/event_bus.js';
export default {
  name: 'Container',    
  props: {
    src: String,
    view: Object,
    step_historys: Array,
    is_install: Boolean,
    vid: String,
  },
  data() {
    return {
      container_height: '100%',
      hover_element_selector: '',
      iframe_handler: {},
      oberserver: null,
      edit_src: '',
      is_try_proxy: false,
      is_connected: false,
      dialog_setting: {
        alert_type: {
            is_show: false,
        },
        is_show: true,
        title: '系統訊息',
        text: "載入網站中...",
        btns: [
            {
                text: '關閉',
                callback: this.closeBtn,
                color: "primary"
            },
            // {
            //     text: '安裝說明',
            //     callback: this.goContainer,
            //     color: "primary"
            // }
        ],
      }
    };
  },
  created: function(){
    eventBus.$on('update-selected-element', this.updateSelectedElement);
    eventBus.$on('get-selected-element-info', this.getElementInfo);
    eventBus.$on('edit-text', this.handleEditText)
    eventBus.$emit('open-dialog', this.dialog_setting)
    this.edit_src = this.src
  },
  mounted: async function(){
    console.log('Container',this.view)
    window.addEventListener('message', this.iframeCallback)
    // window.removeEventListener('message', this.iframeCallback)
  },
  destroyed: function(){
    console.log('Destroyeddd', window)
    window.removeEventListener('message', this.iframeCallback)
    eventBus.$off('update-selected-element', this.updateSelectedElement);
    eventBus.$off('get-selected-element-info', this.getElementInfo);
    eventBus.$off('edit-text', this.handleEditText)
  },
  methods: {
    loadHistory: function(historys){
        for (let idx = 0 ; idx < historys.length; idx++) {
            this.updateSelectedElement(historys[idx], 'next')
        }
    },
    handleIframeLoad: function(event){
        let that = this
        console.log('載入完拉啦啦啦', event.target)
        console.log('type: ', this.device_type)
        console.log('length:', event.target.contentWindow.length)
        let length = event.target.contentWindow.length

        if (length === 0) {
            this.loadedFail('iframe_fail')
        }
        else {
            setTimeout(function(){
                if (that.is_connected === false) {
                    that.loadedFail('sdk_fail')
                }
            }, 3000)
        }

        // // 過了8秒如果都沒拿到connect就換proxy的方式取網頁
        // setTimeout(function(){
        //     if (that.is_connected){
        //         console.log('connect!')
        //         return
        //     }

        //     if (that.is_try_proxy) {
        //         console.log('試過proxy')
        //         that.loadedFail()
        //         return
        //     }

        //     let url = new URL(process.env.VUE_APP_PROXY_URL) 
        //     url.searchParams.append('uri', that.src);
        //     that.edit_src = url.href
        //     that.is_try_proxy = true

        // }, 8000)
    },
    loadedSuccess: async function(){
        this.is_connected = true
        this.dialog_setting = {
            alert_type: {
                is_show: true,
                type: 'success',
                color: 'success',
                icon: 'mdi-check-circle-outline'
            },
            is_show: true,
            title: '系統訊息',
            text: "網站連結成功，進入編輯模式",
            btns: [
                {
                    text: '關閉',
                    callback: this.closeBtn,
                    color: "primary"
                },
            ],
            time: 2000,
        }
        if (this.is_install) {
            this.dialog_setting['text'] = '網站連結成功，代碼安裝完成'
            this.dialog_setting.btns = [
                {
                    text: '返回',
                    callback: this.goBack,
                    color: "primary"
                },
            ]
            this.dialog_setting.time = 300000
        }
        
        eventBus.$emit('open-dialog', this.dialog_setting);

    },
    loadedFail: async function(type){
        console.log('fail_type: ', type)
        this.dialog_setting = {
            alert_type: {
                is_show: true,
                type: 'warning',
                color: 'orange',
                icon: 'mdi-alert-outline'
            },
            is_show: true,
            title: '系統訊息',
            text: "網站上偵測不到Optimize99代碼",
            html: '',
            btns: [
                {
                    text: '返回',
                    callback: this.goBack,
                    color: "grey"
                },
                {
                    text: '關閉',
                    callback: this.closeBtn,
                    color: "primary"
                },
                // {
                //     text: '安裝說明',
                //     callback: this.goContainer,
                //     color: "primary"
                // }
            ],
        }
        
        if (type === 'iframe_fail') {
            this.dialog_setting['html'] = `<p class="mb-0 mt-3">無法載入頁面，請先安裝<a href="${process.env.VUE_APP_CHROME_EXTESION_URL}" target="_blank">Optimize99擴展套件</a></p>`
        }

        eventBus.$emit('open-dialog', this.dialog_setting);
        
    },
    goBack: function(){
        this.$router.go(-1)
    },
    closeBtn: function(){
        eventBus.$emit('open-dialog', {
            is_show: false
        });
    },
    updateSelectedElement: function(data, type){
        console.log('container_data: ', data)
        console.log('contianer_type: ', type)
        console.log('view_id:', this.vid)
        let action = JSON.stringify({
            "action": "updateElement",
            "data": data,
            "type": type,
            "container_id": this.$route.params.container_id,
            "vid": this.vid
        })
        console.log('-----action-----')
        console.log(JSON.parse(action))
        console.log('-----action-----')
        // console.log('refff', this.$refs.iframeRef)
        let iframe = document.getElementById('container_iframe')
        // console.log('refff2', iframe)
        if (this.$refs.iframeRef) {
            this.$refs.iframeRef.contentWindow.postMessage(action, '*');
        }
        else {
            iframe.contentWindow.postMessage(action, '*');
        }

    },
    getElementInfo: function(data){
        // console.log('handleEditText', is_edit)
        let aciton = JSON.stringify({
            "action": "getElementInfo",
            "selector": data.selector,
            "method": data.method,
            "container_id": this.$route.params.container_id
        })
        this.$refs.iframeRef.contentWindow.postMessage(aciton, '*');
        // const $element = this.iframe_handler.querySelector(selector)
        // $element.removeAttribute('contenteditable')
        // const ele_info = this.iframe_handler.getElementInfo($element)
        // this.selected_element_info = ele_info
        // this.$store.commit('setSelectedElementInfo', this.selected_element_info)
    },
    iframeCallback: function(e){
        let that = this
        console.log('wowowow', e)
        const resp_data = e.data
        const data = resp_data.data
        let aciton = {}
        switch (resp_data.action) {
            case 'selected':
                console.log('收更新更新更新')
                eventBus.$emit('update-editor-ele', data);
                // this.$store.commit('setSelectedElementInfo', data.selected_element_info)
                // this.$store.commit('setSelectedElementSelector', data.selected_element_selector)
                // console.log(this.selected_element_selector)
                break;
            case 'init_callback':
                console.log('載入完call back!!!!!!!!!!!!', resp_data.container_id)
                if (resp_data.container_id !== this.$route.params.container_id) {
                    return
                }
                this.loadedSuccess()
                aciton = JSON.stringify({
                    "action": "startEdit",
                    "option": {
                        'css_mapper': this.css_mapper,
                        'attribute_mapper': this.attribute_mapper
                    },
                    "container_id": this.$route.params.container_id
                })
                console.log('this.$refs.iframeRef', this.$refs.iframeRef)
                this.$refs.iframeRef.contentWindow.postMessage(aciton, '*');
                console.log('this.step_historys', this.step_historys)
                setTimeout(function(){
                    that.loadHistory(that.step_historys)
                }, 1300)
                // 載入舊檔
                // if (this.view && this.view.add_column){
                //     let add_column = JSON.parse(this.view.add_column)
                //     if (Array.isArray(add_column.history)){
                //         this.loadHistory(add_column.history)
                //     }
                // }
                break;
            case 'get_element_info':
                console.log('確定修改後callback', data)
                eventBus.$emit('confirm-edit-callback', data);
        }
        
    },
    handleEditText: function(is_edit){
        console.log('handleEditText', is_edit)
        let aciton = JSON.stringify({
            "action": "editText",
            "is_edit": is_edit,
            "container_id": this.$route.params.container_id
        })
        this.$refs.iframeRef.contentWindow.postMessage(aciton, '*');
    }
  },
  computed: {
    ...mapGetters([
        'device_type', 
        'css_mapper',
        'attribute_mapper',
        'is_edit_text',
    ])
  },
  watch: {
  }
};
</script>

<style scoped>
/* ::v-deep .v-application--wrap {
    min-height: fit-content;
} */
.optimize99-ab-test-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5f6367;
    /* position: relative; */
    /* margin-top: 15px; */
}
.optimize99-ab-test-iframe {
    width: 100%;
    height: 100%;
    border: 0px;
}
.optimize99-ab-test-iframe-desktop {
    max-width: 100%;
    height: 100%;
}
.optimize99-ab-test-iframe-mobile {
    max-width: 375px;
}
.optimize99-ab-test-iframe-tablet {
    max-width: 768px;
}
</style>
